import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from '@material-ui/core';

const ConfirmationDialog = ({
                                open,
                                onClose,
                                onConfirm,
                                title = "Confirm Action",
                                message = "Are you sure you want to proceed?",
                                confirmText = "Confirm",
                                cancelText = "Cancel",
                                loading = false,
                                fullWidth = false,
                                // Optional { text, error } shown at the left of the buttons.
                                footerNote = null
                            }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth={fullWidth}
            aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description"
        >
            <DialogTitle id="confirmation-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {footerNote && (
                    <span style={{
                        marginRight: 'auto',
                        paddingLeft: 8,
                        fontSize: '0.75rem',
                        color: footerNote.error ? 'var(--status-declined)' : 'var(--fg-tertiary)',
                    }}>
                        {footerNote.text}
                    </span>
                )}
                <Button onClick={onClose} color="default" disabled={loading}>
                    {cancelText}
                </Button>
                <Button
                    onClick={onConfirm}
                    color="primary"
                    variant="contained"
                    disabled={loading}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;